import { Injectable } from '@angular/core';
import { ObserverService } from './observer.service';
import { Delivery } from '../../models/delivery.schema';

@Injectable()
export class DeliveryObserverService extends ObserverService<[Delivery, string]> { }
